import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var UsersReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default UsersReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Users/UsersReduxProps.ts
// module id = 496
// module chunks = 0